const appConfig: any = {
  // breakpoints
  tabletWidth: 920,
  mobileWidth: 768,
  smallMobileWidth: 500,

  // layout
  headerHeight: 70,
  leftNavWidth: 180,
  dataPanelWidth: 390, //352
  homePageContentWidth: "64rem",

  // search
  searchInputWidth: 500,

  // legend
  minItemsForExpander: 8,

  // router
  routerBasename: "/nvr",

  version: "1.0.0",
};

export default appConfig;
